enum UserLabelType {
  Start = 'Start',
  Email = 'Email',
}

export default UserLabelType;
